/* Tnaheed — global: keep language on links, language pill, instant add-to-cart notification, menu, live search, account link, cart page updates */
(function(){
'use strict';
var d=document,ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var AR=(d.documentElement.getAttribute('lang')||'').indexOf('ar')===0;
function $(s,c){return (c||d).querySelector(s);}
function $$(s,c){return [].slice.call((c||d).querySelectorAll(s));}
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}

/* 0. keep the selected language (e.g. /en) on every internal link */
if(ROOT!=='/'){
  var PRE=ROOT.replace(/\/$/,'');
  var NOLOC=/^\/(cdn|checkout|checkouts|services|apps|tools|wpm|web-pixels|localization|customer_authentication|account\/logout)(\/|$)/;
  var loc=function(a){
    var h=a.getAttribute('href');if(!h||/^(#|mailto:|tel:|javascript:|sms:)/i.test(h))return;
    var u;try{u=new URL(h,location.href);}catch(e){return;}
    if(u.origin!==location.origin)return;
    var p=u.pathname;
    if(p===PRE||p.indexOf(PRE+'/')===0||NOLOC.test(p))return;
    a.setAttribute('href',PRE+(p==='/'?'':p)+u.search+u.hash);
  };
  $$('a[href]').forEach(loc);
  d.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href]');if(a)loc(a);},true);
  new MutationObserver(function(ms){ms.forEach(function(m){[].forEach.call(m.addedNodes,function(n){if(n.nodeType!==1)return;if(n.matches&&n.matches('a[href]'))loc(n);if(n.querySelectorAll)[].forEach.call(n.querySelectorAll('a[href]'),loc);});});}).observe(d.body,{childList:true,subtree:true});
}

/* 1. language pill into header icons */
var lang=$('#th-lang');
if(lang){var slot=$('#ntheader .nt_action');if(slot)slot.insertBefore(lang,slot.firstChild);else lang.classList.add('is-float');lang.classList.add('is-ready');}

/* 2. Arabic view: replace leftover English words in the old header */
if(AR){var MAP={'TnaheedOil':'تناهيد أويل','Tnaheed Oil':'تناهيد أويل'};var hdr=$('#ntheader');
  if(hdr){var w=d.createTreeWalker(hdr,4,null),x;while((x=w.nextNode())){var v=x.nodeValue.trim();if(MAP[v])x.nodeValue=x.nodeValue.replace(v,MAP[v]);}}}

/* 3. cart count everywhere */
function setCount(c){c=Math.max(0,parseInt(c,10)||0);$$('.jsccount,[data-cart-count],.th-cart-count').forEach(function(n){n.textContent=c;if(n.classList.contains('th-tab__n')){if(c>0)n.removeAttribute('data-zero');else n.setAttribute('data-zero','');}});}
function syncCount(){return fetch(ROOT+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){setCount(c.item_count);}).catch(function(){});}

/* 4. top notification */
var note=$('#th-note'),nt;
function hideNote(){if(note)note.classList.remove('is-on');}
function showNote(ok,o){
  if(!note)return;o=o||{};
  var T=function(k){return note.getAttribute('data-t-'+k)||'';},dur=ok?4500:5500;
  var icon=ok?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.8 2.8L16 10"/></svg>':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>';
  var h='<div class="th-note__row">'+(o.img?'<span class="th-note__img"><img src="'+esc(o.img)+'" alt="" width="54" height="54"></span>':'')+
    '<div class="th-note__txt"><span class="th-note__st">'+icon+esc(ok?T('ok'):(o.msg||T('err')))+'</span>'+(o.t?'<span class="th-note__t">'+esc(o.t)+'</span>':'')+'</div>'+
    '<button type="button" class="th-note__x" data-th-note-x aria-label="'+esc(T('close'))+'"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>'+
    (ok?'<div class="th-note__btns"><a class="th-note__view" href="'+esc(note.getAttribute('data-cart'))+'">'+esc(T('view'))+'</a><a class="th-note__ck" href="'+ROOT+'checkout">'+esc(T('ck'))+'</a></div>':'')+
    '<span class="th-note__bar" style="--t:'+dur+'ms"><i></i></span>';
  note.innerHTML=h;note.classList.toggle('is-err',!ok);
  note.classList.remove('is-on');void note.offsetWidth;note.classList.add('is-on');
  clearTimeout(nt);nt=setTimeout(hideNote,dur);
}
if(note){
  note.addEventListener('mouseenter',function(){clearTimeout(nt);});
  note.addEventListener('mouseleave',function(){clearTimeout(nt);nt=setTimeout(hideNote,1800);});
  note.addEventListener('click',function(e){if(e.target.closest('[data-th-note-x]'))hideNote();});
}

/* 5. add to cart: instant feedback, request in background */
function info(btn){
  var o={t:'',img:''},box=btn&&btn.closest('.th-card,.th-slide,.th-spot,.th-pdp');if(!box)return o;
  var t=box.querySelector('.th-card__title,.th-slide__title,.th-spot__t,.th-pdp__t');if(t)o.t=t.textContent.replace(/\s+/g,' ').trim();
  var im=box.querySelector('img');if(im)o.img=im.currentSrc||im.src;return o;
}
function sections(){return $('#shopify-section-th-cart')?'th-cart':'';}
function post(url,body){
  return fetch(ROOT+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
    .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});});
}
function apply(s){
  if(!s||!s['th-cart'])return;var host=$('#shopify-section-th-cart');if(!host)return;
  var t=d.createElement('div');t.innerHTML=s['th-cart'];var n=$('.th-cartp',t),o=$('.th-cartp',host);if(n&&o)o.parentNode.replaceChild(n,o);
}
function add(id,qty,btn){
  if(!id)return;qty=qty||1;
  var cur=parseInt((($('.th-cart-count')||{}).textContent)||'0',10)||0;
  setCount(cur+qty);showNote(true,info(btn));
  if(btn){btn.classList.add('is-done');setTimeout(function(){btn.classList.remove('is-done');},1600);}
  if(navigator.vibrate){try{navigator.vibrate(10);}catch(e){}}
  var body={items:[{id:parseInt(id,10),quantity:qty}]},sec=sections();
  if(sec){body.sections=sec;body.sections_url=location.pathname;}
  post('cart/add.js',body).then(function(j){apply(j.sections);syncCount();d.dispatchEvent(new CustomEvent('th:cart'));})
  .catch(function(err){if(btn)btn.classList.remove('is-done');showNote(false,{msg:err&&err.description});syncCount();});
}
function change(key,qty,row){
  if(row)row.classList.add('is-busy');
  var body={id:key,quantity:qty},sec=sections();if(sec){body.sections=sec;body.sections_url=location.pathname;}
  post('cart/change.js',body).then(function(j){apply(j.sections);setCount(j.item_count);})
  .catch(function(err){if(row)row.classList.remove('is-busy');showNote(false,{msg:err&&err.description});});
}
d.addEventListener('click',function(e){
  var t=e.target;if(!t.closest)return;
  var b=t.closest('[data-th-add]');
  if(b){e.preventDefault();add(b.getAttribute('data-th-add'),1,b);return;}
  var q=t.closest('[data-th-qty]');
  if(q){e.preventDefault();var row=q.closest('[data-key]');if(!row)return;
    var c=parseInt(row.getAttribute('data-qty'),10)||0,v=q.getAttribute('data-th-qty'),n=v==='0'?0:Math.max(0,c+parseInt(v,10));
    if(n!==c)change(row.getAttribute('data-key'),n,row);}
});
window.addEventListener('submit',function(e){
  var f=e.target&&e.target.closest&&e.target.closest('form[data-th-pform]');if(!f)return;
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
  var fd=new FormData(f);add(fd.get('id'),Math.max(1,parseInt(fd.get('quantity')||'1',10)),f.querySelector('[data-th-submit]'));
},true);

/* 6. menu + search overlays; take over old theme buttons (capture runs first) */
var menu=$('#th-menu'),srch=$('#th-srch'),lastFocus=null;
function isOpen(el){return el&&el.classList.contains('is-open');}
function open(el,sel){if(!el)return;close(menu);close(srch);lastFocus=d.activeElement;el.classList.add('is-open');el.setAttribute('aria-hidden','false');d.documentElement.classList.add('th-noscroll');
  setTimeout(function(){var f=$(sel,el);if(f)try{f.focus({preventScroll:true});}catch(x){}},90);}
function close(el){if(!isOpen(el))return;el.classList.remove('is-open');el.setAttribute('aria-hidden','true');if(!isOpen(menu)&&!isOpen(srch))d.documentElement.classList.remove('th-noscroll');}
function closeAll(){close(menu);close(srch);if(lastFocus&&lastFocus.focus)try{lastFocus.focus({preventScroll:true});}catch(x){}}
d.addEventListener('keydown',function(e){if(e.key==='Escape'&&(isOpen(menu)||isOpen(srch)))closeAll();});
window.addEventListener('click',function(e){
  if(e.defaultPrevented||e.metaKey||e.ctrlKey||e.shiftKey)return;
  var t=e.target;if(!t.closest)return;
  var stop=function(){e.stopPropagation();e.stopImmediatePropagation();};
  if(t.closest('[data-th-close]')){e.preventDefault();closeAll();return;}
  if(menu&&t.closest('[data-id="#nt_menu_canvas"],.push-menu-btn,[data-th-open-menu]')){e.preventDefault();stop();open(menu,'.th-menu__x');return;}
  if(srch&&t.closest('[data-id="#nt_search_canvas"],#ntheader .icon_search,[data-th-open-search]')){e.preventDefault();stop();open(srch,'[data-th-q]');return;}
  var c=t.closest('[data-id="#nt_cart_canvas"],#ntheader .icon_cart');
  if(c){stop();if(!t.closest('a[href]')){e.preventDefault();location.href=ROOT+'cart';}return;}
  /* account icon: go straight to the store's sign-in (no old slide panel) */
  var acc=t.closest('[data-id="#nt_login_canvas"],#ntheader .my-account');
  if(acc){stop();if(!t.closest('a[href]')){e.preventDefault();location.href=ROOT+'account';}}
},true);

/* 7. live search (store search rendered by sections/th-search-live; works in Arabic) */
if(srch){
  var q=$('[data-th-q]',srch),res=$('[data-th-sres]',srch),def=$('[data-th-sdef]',srch),timer,ctrl,seq=0;
  var run=function(v){
    var my=++seq;if(ctrl)ctrl.abort();ctrl=window.AbortController?new AbortController():null;
    res.hidden=false;def.hidden=true;res.innerHTML='<div class="th-srch__spin"></div>';
    fetch(ROOT+'search?type=product&options%5Bprefix%5D=last&q='+encodeURIComponent(v)+'&section_id=th-search-live',ctrl?{signal:ctrl.signal}:{})
    .then(function(r){return r.text();}).then(function(html){if(my===seq)res.innerHTML=html;})
    .catch(function(e){if(!e||e.name!=='AbortError')res.innerHTML='';});
  };
  q.addEventListener('input',function(){clearTimeout(timer);var v=q.value.trim();if(v.length<2){seq++;if(ctrl)ctrl.abort();res.hidden=true;def.hidden=false;return;}timer=setTimeout(function(){run(v);},250);});
}
})();